import { render, staticRenderFns } from "./ButtonWishlist.vue?vue&type=template&id=c46e2c6a&scoped=true&"
import script from "./ButtonWishlist.ts?vue&type=script&lang=ts&"
export * from "./ButtonWishlist.ts?vue&type=script&lang=ts&"
import style0 from "./ButtonWishlist.scss?vue&type=style&index=0&id=c46e2c6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46e2c6a",
  null
  
)

export default component.exports